import axios from "axios";
import { API } from "./api";

// What the gallery decided and why (shown under ?debug=1); fallbacks are also reported, anonymously, to /api/diag
export const diagState = (window.__afaeDiag = window.__afaeDiag || { view: "3d", reason: null, renderer: null, lost: 0, errors: [], events: [] });
let sent = 0;
// errors the page met (for ?debug=1)
window.addEventListener("error", (e) => (diagState.errors = [...diagState.errors.slice(-4), String(e.message || e.type).slice(0, 120)]));
window.addEventListener("unhandledrejection", (e) => (diagState.errors = [...diagState.errors.slice(-4), String(e.reason?.message || e.reason).slice(0, 120)]));
export function diagNote(patch) {
  Object.assign(diagState, patch);
  window.dispatchEvent(new Event("afae-diag"));
}
export function diag(reason, detail = "") {
  diagState.events = [...diagState.events.slice(-9), { reason, detail: String(detail).slice(0, 200), t: Math.round(performance.now()) }];
  diagNote({ reason });
  if (sent++ >= 6) return;
  axios.post(`${API}/diag`, { reason, detail: String(detail).slice(0, 400), renderer: diagState.renderer || "", view: diagState.view }).catch(() => {});
}
export function rendererOf(gl) {
  try {
    const c = gl.getContext();
    const d = c.getExtension("WEBGL_debug_renderer_info");
    return String(d ? c.getParameter(d.UNMASKED_RENDERER_WEBGL) : c.getParameter(c.RENDERER)).slice(0, 120);
  } catch {
    return "unknown";
  }
}
